import { Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import InputField from "../../../atoms/InputField";
import Button from "../../../atoms/Button";
import { PropagateLoader } from "react-spinners";
import NoData from "../../../atoms/NoData";
import DataTable from "react-data-table-component";
import { MdDelete, MdEdit } from "react-icons/md";
import useModal from "../../../../hooks/useModal";
import CardTables from "../../../atoms/CardTables";
import { DELETE_ASSISTANT, GET_ASSISTANTS_BY_CLIENT, REGISTER_ASSITANT_BY_ENTERPRISE, UPDATE_ASSISTANT } from "../../../../api/apiUsuariosExt";
import Modal from "../../../molecules/Modal";
import ModalConfirm from "../../../molecules/ModalConfirm";

const ModalCreateExAs = ({ client }) => {
    const [loading, setLoading] = useState(false);
    const [asistentes, setAsistentes] = useState();
    const [asistente, setAsistente] = useState();
    const { open:open2, close:close2, isOpen:isOpen2 } = useModal();
    const { open:open3, close:close3, isOpen:isOpen3 } = useModal();
    const [expandedRow, setExpandedRow] = useState(null);

    const getAssistants =  useCallback(async () => {
        try {
            setLoading(true);
            const assistantsData =  await GET_ASSISTANTS_BY_CLIENT(client.userId);
            setAsistentes(assistantsData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [client]);

    useEffect(()=> {
        getAssistants();
    }, [getAssistants]);
    
    const handleOpenEdit = (assist) =>{
        setAsistente(assist);
        open2();
    };

    const handleOpenDelete = (assist) => {
        setAsistente(assist);
        open3();
    };

    const handleDelete = async () => {
        try {
            await DELETE_ASSISTANT(asistente?.id)
            toast.success("Eliminado correctamente");
            getAssistants();
            close3();
        } catch (error) {
            toast.error("Error al eliminar");
            console.error(error);
        }
    };

    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.name) { errors.name = "El nombre es requerido"; }
        if (!values.email) { errors.email = "El email es requerido"; } 
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            await REGISTER_ASSITANT_BY_ENTERPRISE(values)
            toast.success("Registro exitoso");
            getAssistants();
            resetForm();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const handleUpdate = async (values, { setSubmitting }) => {
        try {
            await UPDATE_ASSISTANT(asistente.id, values)
            toast.success("Actualizado correctamente");
            getAssistants();
            close2();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = { name: "", email: "", cellphone: "", userId: client.userId };

    const initialValuesUpdate = { 
        name: asistente?.name || "", 
        email: asistente?.email || "", 
        cellphone: asistente?.cellphone || "", 
        userId: asistente?.userId || client.userId 
    };

    const columns = [
        { name: "Nombre", selector: row => row.name },
        { name: "Correo electronico", cell: row => (
            <div className="flex flex-col">
                <p> {row.email}  </p>
                <p> {row.cellphone} </p>
            </div>
        )},
        { name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-2">
                <Button text={<MdEdit size={30}/>} bgColor="blue" width="w-12" onClick={()=> handleOpenEdit(row)}/>
                <Button text={<MdDelete size={30}/>} bgColor="red" width="w-12" onClick={()=> handleOpenDelete(row)}/>
            </div>
        )},
    ];

    const columnsResponsive = [
        { name: "Información", cell: row => (
            <div className="flex flex-col">
                <p> {row.name} </p>
                <p> {row.email}  </p>
                <p> {row.cellphone} </p>
            </div>
        )},
    ];

    const ExpandedComponent = ({ data }) => (
        <div className="p-2 w-full flex flex-row justify-around">
            <Button text={<MdEdit size={25} />} bgColor="blue" width="w-12" onClick={() => handleOpenEdit(data)} />
            <Button text={<MdDelete size={25} />} bgColor="red" width="w-12" onClick={() => handleOpenDelete(data)} />
        </div>
    );    

    const conditionalRowStyles = [
        {
            when: row => row?.id === expandedRow?.id,
            style: { backgroundColor: '#f3f4f6', },
        },
    ]; 

    return (
        <div className="space-y-4">
            <CardTables>
                <div className="block md:hidden">
                    <DataTable
                        data={asistentes}
                        progressPending={loading}
                        columns={columnsResponsive}
                        progressComponent={
                            <div className="w-full h-20 flex justify-center items-center">
                                <PropagateLoader color="red" />
                            </div>
                        }
                        noDataComponent={<NoData/>}
                        pagination
                        responsive
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        expandableRowExpanded={(row) => row?.id === expandedRow?.id}
                        onRowExpandToggled={(expanded, row) => {
                            setExpandedRow(expanded ? row : null);
                        }}
                        conditionalRowStyles={conditionalRowStyles}
                    />
                </div>
                <div className="hidden md:block">
                    <DataTable
                        data={asistentes}
                        progressPending={loading}
                        columns={columns}
                        progressComponent={
                            <div className="w-full h-20 flex justify-center items-center">
                                <PropagateLoader color="red" />
                            </div>
                        }
                        noDataComponent={<NoData/>}
                        pagination
                    />
                </div>
            </CardTables>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validate} >
                {({ isSubmitting }) => (
                    <Form className="w-full flex flex-col items-center justify-center text-center space-y-4">
                        <InputField name="name" label="Nombre completo" placeholder="Nombre completo" capitalize />
                        <InputField name="email" label="Correo electrónico" placeholder="CORREO ELECTRÓNICO" />
                        <InputField name="cellphone" label="Numero de telefono" placeholder="Número de teléfono" type="number" capitalize/>
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Registrar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
            {isOpen2 && 
                <Modal title="Editar asistente" onClose={close2}>
                    <Formik initialValues={initialValuesUpdate} onSubmit={handleUpdate} validate={validate} >
                        {({ isSubmitting }) => (
                            <Form className="w-full flex flex-col items-center justify-center text-center space-y-4">
                                <InputField name="name" label="Nombre completo" placeholder="Nombre completo" capitalize />
                                <InputField name="email" label="Correo electrónico" placeholder="CORREO ELECTRÓNICO" />
                                <InputField name="cellphone" label="Numero de telefono" placeholder="Número de teléfono" type="number" capitalize />
                                <Button text={isSubmitting ? <PropagateLoader color="red" /> : "actualizar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                            </Form>
                        )}
                    </Formik>
                </Modal>
            }
            {isOpen3 &&    
                <ModalConfirm onClose={close3} onConfirm={handleDelete} />
            }
        </div>
    );
};

export default ModalCreateExAs;